import React from 'react';

import { StandardButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useTranslation } from '../../translations';

const CreditCardNoAccess: React.FC = () => {
    const translated = useTranslation().creditCardScreen;

    return (
        <>
            <InfoCard
                skipBackground
                img={<RichIcon className="icon-error" type={RichIconTypes.SPERR_KORT_MIDLERTIDIG} />}
            >
                <InfoCard.TitleH3>{translated.creditCardLimitErrorTitle}</InfoCard.TitleH3>
                <p>{translated.creditCardLimitErrorText}</p>
                <StandardButton className="button-ok" onClick={() => window.history.back()}>
                    {translated.buttonOk}
                </StandardButton>
            </InfoCard>
        </>
    );
};

export default CreditCardNoAccess;
